/****************************************************
 * Module Name:  sellMemoModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
} from "@mui/material";
import { useState } from "react";

const ExportComponent = ({
  canEdit,
  countryOfOrigin,
  //   setCountryOfOrigin,
  insurredBy,
  //   setInsurredBy,
  portOfLoading,
  //   setPortOfLoading,
  countryOfFinalDestination,
  //   setCountryOfFinalDestination,
  shippedBy,
  //   setShippedBy,
  portOfDischarge,
  //   setPortOfDischarge,
  finalDestination,
  //   setFinalDestination,
  bankThrough,
  //   setBankThrough,
  exportComponentData,
  notPermitted,
}) => {
  const [countryOfOrigins, setCountryOfOrigins] = useState(countryOfOrigin);
  const [insurredBys, setInsurredBys] = useState(insurredBy);
  const [portOfLoadings, setPortOfLoadings] = useState(portOfLoading);
  const [countryOfFinalDestinations, setCountryOfFinalDestinations] = useState(
    countryOfFinalDestination
  );
  const [shippedBys, setShippedBys] = useState(shippedBy);
  const [portOfDischarges, setPortOfDischarges] = useState(portOfDischarge);
  const [finalDestinations, setFinalDestinations] = useState(finalDestination);

  useEffect(() => {
    setCountryOfOrigins(countryOfOrigin);
    setPortOfLoadings(portOfLoading);
    setPortOfDischarges(portOfDischarge);
    setFinalDestinations(finalDestination);
    setCountryOfFinalDestinations(countryOfFinalDestination);
  }, [countryOfOrigin, portOfLoading, portOfDischarge, finalDestination, countryOfFinalDestination]);

  const [bankThroughs, setBankThroughs] = useState(bankThrough);

  let data = {
    countryoforigin: countryOfOrigins,
    ensuredby: insurredBys,
    portofloading: portOfLoadings,
    countryoffinaldestination: countryOfFinalDestinations,
    shippedby: shippedBys,
    portofdischarge: portOfDischarges,
    finaldestination: finalDestinations,
    bankthrough: bankThroughs,
  };

  useEffect(() => {
    exportComponentData(data);
  }, []);

  useEffect(() => {
    exportComponentData(data);
  }, [
    countryOfOrigins,
    insurredBys,
    portOfLoadings,
    countryOfFinalDestinations,
    shippedBys,
    portOfDischarges,
    finalDestinations,
    bankThroughs,
  ]);

  return (
    <Box
      display={"grid"}
      gridTemplateColumns={"1fr 1fr 1fr"}
      width={"100%"}
      height={"100%"}
      gap={"15px"}
    >
      <Box display={"flex"} flexDirection={"column"}>
        <Box sx={{ display: "flex", width: "100%" }}>
          <TextField
            margin="normal"
            fullWidth
            label="Country of origin"
            placeholder="Enter Country of origin"
            value={countryOfOrigins}
            onChange={(e) => setCountryOfOrigins(e.target.value)}
            disabled={(canEdit || !notPermitted) ? false : true}
          />
        </Box>
        <Box sx={{ display: "flex", width: "100%" }}>
          <TextField
            margin="normal"
            fullWidth
            label="Insurred by"
            placeholder="Enter Insurred by"
            value={insurredBys}
            onChange={(e) => setInsurredBys(e.target.value)}
            disabled={(canEdit || !notPermitted) ? false : true}
          />
        </Box>
        <Box sx={{ display: "flex", width: "100%" }}>
          <TextField
            margin="normal"
            fullWidth
            label="Port of Loading"
            placeholder="Enter Port of Loading"
            value={portOfLoadings}
            onChange={(e) => setPortOfLoadings(e.target.value)}
            disabled={(canEdit || !notPermitted) ? false : true}
          />
        </Box>
      </Box>
      <Box display={"flex"} flexDirection={"column"}>
        <Box sx={{ display: "flex", width: "100%" }}>
          <TextField
            margin="normal"
            fullWidth
            label="Country of Final Destination"
            placeholder="Enter Country of Final Destination"
            value={countryOfFinalDestinations}
            onChange={(e) => setCountryOfFinalDestinations(e.target.value)}
            disabled={(canEdit || !notPermitted) ? false : true}
          />
        </Box>
        <Box sx={{ display: "flex", width: "100%" }}>
          <TextField
            margin="normal"
            fullWidth
            label="Shipped by"
            placeholder="Enter Shipped by"
            value={shippedBys}
            onChange={(e) => setShippedBys(e.target.value)}
            disabled={(canEdit || !notPermitted) ? false : true}
          />
        </Box>
        <Box sx={{ display: "flex", width: "100%" }}>
          <TextField
            margin="normal"
            fullWidth
            label="Port of Discharge"
            placeholder="Enter Port of Discharge"
            value={portOfDischarges}
            onChange={(e) => setPortOfDischarges(e.target.value)}
            disabled={(canEdit || !notPermitted) ? false : true}
          />
        </Box>
      </Box>
      <Box display={"flex"} flexDirection={"column"}>
        <Box sx={{ display: "flex", width: "100%" }}>
          <TextField
            margin="normal"
            fullWidth
            label="Final Destination"
            placeholder="Enter Final Destination"
            value={finalDestinations}
            onChange={(e) => setFinalDestinations(e.target.value)}
            disabled={(canEdit || !notPermitted) ? false : true}
          />
        </Box>
        <FormGroup sx={{ mt: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={bankThroughs}
                onChange={() => setBankThroughs(!bankThroughs)}
                disabled={(canEdit || !notPermitted) ? false : true}
              />
            }
            label="Bank Through"
          />
        </FormGroup>
      </Box>
    </Box>
  );
};

export default ExportComponent;
